import {PINNED_PAGES_PIN, PINNED_PAGES_UNPIN, PINNED_PAGES_GET_ALL, PINNED_PAGES_SAVE_SCROLL, PINNED_PAGES_REMOVE_ALL} from '../constants';

const pinnedPagesReducer = (state = {}, action) => {
  switch (action.type) {
    case PINNED_PAGES_PIN:
    case PINNED_PAGES_UNPIN:
    case PINNED_PAGES_GET_ALL:
    case PINNED_PAGES_REMOVE_ALL:
    case PINNED_PAGES_SAVE_SCROLL:
      return action.payload;
    default:
      return state;
  }
};

export default pinnedPagesReducer;
